import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-previous-phase',
  templateUrl: './previous-phase.component.html',
  styleUrls: ['./previous-phase.component.scss']
})
export class PreviousPhaseComponent implements OnInit {
  @Output() isPreviousPhaseModalVisible=new EventEmitter<boolean>();

  constructor() { }
  ngOnInit(): void {
  }

  documentPreviousPhase(){
    this.isPreviousPhaseModalVisible.emit(true);
  }
}
